import { featuredAuthors } from '@/mocks/manga';

const authorAvatarUrls: Record<string, string> = {
  'author-ink-001': 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20female%20manga%20artist%20with%20glasses%2C%20creative%20studio%20background%2C%20warm%20lighting%2C%20artistic%20style%2C%20professional%20headshot%2C%20soft%20expression&width=160&height=160&seq=author-ink-001&orientation=squarish',
  'author-night-002': 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20serious%20Chinese%20male%20manga%20creator%20with%20artistic%20vibe%2C%20creative%20workspace%2C%20warm%20ambient%20lighting%2C%20professional%20headshot%2C%20contemplative%20expression&width=160&height=160&seq=author-night-002&orientation=squarish',
  'author-fantasy-003': 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Japanese-style%20female%20illustrator%2C%20colorful%20studio%20background%2C%20bright%20creative%20lighting%2C%20professional%20headshot%2C%20cheerful%20expression&width=160&height=160&seq=author-fantasy-003&orientation=squarish',
  'author-moon-004': 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20elegant%20Chinese%20female%20artist%20with%20traditional%20aesthetic%2C%20tea%20ceremony%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%2C%20gentle%20smile&width=160&height=160&seq=author-moon-004&orientation=squarish',
  'author-coffee-005': 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20male%20artist%20in%20a%20cozy%20cafe%2C%20warm%20coffee%20shop%20lighting%2C%20casual%20style%2C%20professional%20headshot%2C%20relaxed%20expression&width=160&height=160&seq=author-coffee-005&orientation=squarish',
  'author-dragon-006': 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20intense%20Chinese%20male%20manga%20creator%2C%20action%20pose%20studio%20setting%2C%20dramatic%20lighting%2C%20professional%20headshot%2C%20powerful%20presence&width=160&height=160&seq=author-dragon-006&orientation=squarish',
};

export default function CreatorZone() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70" id="creators">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            创作者专区
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            黄漫天堂签约了众多优秀的漫画创作者，为你带来独特的原创内容体验
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredAuthors.map((author) => (
            <div
              key={author.name}
              className="flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden bg-background-100 mb-3 ring-2 ring-background-200 group-hover:ring-primary-200 transition-all duration-300">
                <img
                  src={authorAvatarUrls[author.avatarSeq] || authorAvatarUrls['author-ink-001']}
                  alt={author.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-foreground-900 text-sm font-heading whitespace-nowrap">
                {author.name}
              </h4>
              <p className="text-[10px] text-foreground-500 mt-1 bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                {author.specialty}
              </p>
              <div className="flex items-center gap-3 mt-2 text-[10px] text-foreground-400">
                <span>{author.works}部作品</span>
                <span>{(author.followers / 10000).toFixed(0)}万粉丝</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button className="px-6 py-2.5 rounded-lg border border-background-300 text-foreground-600 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-user-add-line mr-1.5"></i>成为创作者
          </button>
        </div>
      </div>
    </section>
  );
}